import { useCallback, useState } from 'react'
import { reserveNameUrl } from '../providers/EnvContextProvider';

export default function useReserveEntity() {  
  const [isValid, setValid] = useState({});

  const onReserveOk = useCallback(async (responseData) => {
    if (!responseData.ok) {      
      const msg = `[useReserveUsername] HTTP Error: ${responseData.status}`;
      // console.log(msg);
      throw new Error(msg);
    }
    
    const data = await responseData.json();
    // TODO 1: return a primitive boolean (resolve the Promise).
    // TODO 2: verify the data.entity === path requested AND data.reservedName === valueToReserve requested
    setValid(prevValid => ({...prevValid, [data.entity]:true}));
    // console.log('[useReserveEntity] Successfully Reserved [data: %s]', JSON.stringify(data));
    return true;
  }, []);


  const reserveEntity = useCallback(async (entity, valueToReserve) => {
    if (!valueToReserve)  {
      setValid(prevValid => ({...prevValid, [entity]:false}));
      console.log('[useReserveEntity] valueToReserve NOT provided. Returning FALSE');
      return false;
    }

    return fetch(reserveNameUrl, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'entity': entity,
        'requestedName': valueToReserve
      })
    })
    .then(onReserveOk)
    .catch(error => {
      setValid(prevValid => ({...prevValid, [entity]:false}));
      console.error('[useReserveEntity] Returning `false` [Reserve Error: %s] [%s: %s]', error, entity, valueToReserve);
      return false;  
    });
  }, [onReserveOk]);

  return {
    reserveEntity,
    isValid
  }  
}
